import PropTypes from "prop-types";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Video } from "lucide-react";

export function DemoVideoUnavailableDialog({ open, onOpenChange, onBookDemo }) {
  const book = () => {
    onOpenChange(false);
    onBookDemo?.();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100vw-1.5rem)] sm:max-w-[420px]" data-testid="demo-video-unavailable-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[15px]">
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-slate-100 text-slate-500">
              <Video size={16} />
            </span>
            {"Walkthrough coming soon"}
          </DialogTitle>
          <DialogDescription className="text-[13px] leading-relaxed pt-1">
            We&apos;re finishing a 2-minute tour of Sellyx. Start a free trial to explore on your own, or book a live walkthrough with our team.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col-reverse sm:flex-row gap-2 pt-1">
          <Button variant="outline" className="flex-1" onClick={() => onOpenChange(false)} data-testid="demo-video-close">
            Close
          </Button>
          {onBookDemo && (
            <Button className="flex-1" onClick={book} data-testid="demo-video-book-call">
              Book a live demo
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

DemoVideoUnavailableDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  onBookDemo: PropTypes.func,
};
